import { API_URL } from '../environment';
import Company from '../model/Company';
import Reseller from '../model/reseller';
import fetcher from '../utils/fetcher';

export const getResellerList = async () => {
  return fetcher(`${API_URL}/v1/reseller/`, {
    method: 'GET',
  }).then((data) => data as Reseller[]);
};

export const getResellerCompanies = async (resellerId: string) => {
  return fetcher(`${API_URL}/v1/reseller/${resellerId}/companies?limit=400`, {
    method: 'GET',
  }).then((data) => data as Company[]);
};

export const getReseller = async (resellerId: string) => {
  return fetcher(`${API_URL}/v1/reseller/${resellerId}`, {
    method: 'GET',
  }).then((data) => data as Reseller);
};

export const createReseller = async (reseller: Omit<Reseller, 'id'>) => {
  return fetcher(`${API_URL}/v1/reseller/`, {
    method: 'POST',
    data: JSON.stringify(reseller),
  }).then((data) => data as Reseller);
};

export const updateReseller = async (resellerId: string, reseller: Partial<Reseller>) => {
  return fetcher(`${API_URL}/v1/reseller/${resellerId}`, {
    method: 'PUT',
    data: JSON.stringify(reseller),
  });
};
